import React, { useContext, useEffect, useState } from 'react';
import {
  Typography,
  Card,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { LoadingContext } from '../../context/LoadingContext';

const StudentTransactions = () => {
  const { setLoading } = useContext(LoadingContext);
  const [filterType, setFilterType] = useState('all'); // State for filter type
  const [transactions, setTransactions] = useState([
    { id: 1, date: '2023-10-01', amount: 500, type: 'Credit' },
    { id: 2, date: '2023-10-02', amount: -200, type: 'Debit' },
    { id: 3, date: '2023-10-03', amount: 300, type: 'Credit' },
    { id: 4, date: '2023-10-04', amount: -100, type: 'Debit' },
  ]);

  // Simulate fetching data
  useEffect(() => {
    setLoading(true); // Show loading screen
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulate 2-second delay
      setLoading(false); // Hide loading screen
    };

    fetchData();
  }, [setLoading]);


  // Filter transactions based on type
  const filteredTransactions = transactions.filter((transaction) => {
    if (filterType === 'all') return true;
    return transaction.type.toLowerCase() === filterType.toLowerCase();
  });

  // Export filtered transactions to CSV
  const exportToCSV = () => {
    const csvHeader = ['Date', 'Amount', 'Type'].join(',');
    const csvRows = filteredTransactions
      .map((transaction) => `${transaction.date},${transaction.amount},${transaction.type}`)
      .join('\n');
    const csvContent = `${csvHeader}\n${csvRows}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'transactions.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Box sx={{ padding: 3 }}>
      {/* Transactions Section */}
      <Typography variant="h6" sx={{ fontFamily: 'Fredoka One', color: '#004aad', mb: 2 }}>
        Transactions
      </Typography>

      {/* Filter Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Filter by Type</InputLabel>
          <Select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            label="Filter by Type"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="credit">Credit</MenuItem>
            <MenuItem value="debit">Debit</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          onClick={exportToCSV}
          sx={{
            backgroundColor: '#004aad',
            '&:hover': { backgroundColor: '#003a8c' },
            fontFamily: 'Fredoka One',
            textTransform: 'none',
            fontSize: '1rem',
            padding: '10px 20px',
          }}
        >
          Export to CSV
        </Button>
      </Box>

      {/* Transactions Table */}
      <TableContainer component={Paper} sx={{ boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontFamily: 'Fredoka One', color: '#004aad' }}>Date</TableCell>
              <TableCell sx={{ fontFamily: 'Fredoka One', color: '#004aad' }}>Amount</TableCell>
              <TableCell sx={{ fontFamily: 'Fredoka One', color: '#004aad' }}>Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTransactions.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.date}</TableCell>
                <TableCell sx={{ color: row.amount > 0 ? 'green' : 'red' }}>
                  ${row.amount}
                </TableCell>
                <TableCell>{row.type}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default StudentTransactions;